module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Socks-f841421ea08624b8ac7b452fc3c12bc9.svg";